import axios from "axios";
import { isTokenExpired, refreshToken } from "./utils/TokenUtils";

const BASE_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
    baseURL: BASE_URL,
    withCredentials: true,
});

let isRefreshing = false;
let refreshSubscribers = [];

const onRefreshed = (token) => {
    refreshSubscribers.map((callback) => callback(token));
    refreshSubscribers = [];
};

const addRefreshSubscriber = (callback) => {
    refreshSubscribers.push(callback);
};

api.interceptors.request.use(
    async (config) => {
        let token = localStorage.getItem('_token');

        if (isTokenExpired(token)) {
            if (!isRefreshing) {
                isRefreshing = true;
                try {
                    const newToken = await refreshToken();
                    localStorage.setItem('_token', newToken);
                    token = newToken;
                    onRefreshed(newToken);
                }catch(error){
                    refreshSubscribers.map((callback) => callback(null));
                    refreshSubscribers = [];
                    return Promise.reject(new Error('Token refresh failed.'));
                } 
                finally {
                    isRefreshing = false;
                }
            }

            // Create a promise that waits for the refresh to complete
            return new Promise((resolve) => {
                addRefreshSubscriber((newToken) => {
                    config.headers['Authorization'] = `Bearer ${newToken}`;
                    resolve(config);
                });
            });
        } else {
            config.headers['Authorization'] = `Bearer ${token}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

export default api;
